'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.open-data').config(translationsConfig);

    /* @ngInject */
    function translationsConfig($translateProvider) {

        $translateProvider.translations('el', {
            'front-page': {
                'The city': 'Η πόλη',
                'citizens': 'δημότες',
                'citizens since': 'δημότες από το {{date | date: "yyyy"}}',
                'residents': 'κάτοικοι',
                'The citizens': 'Οι πολίτες',
                'weddings': 'γάμοι',
                'divorces': 'διαζύγια',
                'Weather conditions': 'Καιρικές συνθήκες'
            },
            'open-data': {
                'Municipal open data': 'Ανοικτά δεδομένα από άλλες πηγές του Δήμου Ηρακλείου',
                'Municipal Roll': 'Δημοτολόγιο',
                'Civil Register': 'Ληξιαρχείο',
                'Open Data': 'Ανοικτά δεδομένα',
                'Fiscal data': 'Οικονομικά στοιχεία',
                'Datasets': 'Σύνολα δεδομένων',
                'Library': 'Βικελαία Δημοτική Βιβλιοθήκη',
                'Social service': 'Κοινωνική υπηρεσία',
                'Date': 'Ημερομηνία',

                'dataset-url-attr': 'url_el',
                'dataset-name-attr': 'name_el',

                'download-button': {
                    'Download': 'Λήψη',
                    'CSV file': 'Αρχείο CSV',
                    'Image': 'Εικόνα',
                    'Vector image': 'Διανυσματική εικόνα'
                },

                'see more': 'περισσότερα',

                'widgets': {
                    'the-city': {
                        'The City': 'Η πόλη',

                        'phrase:population': 'Το έτος <em>{{date | date:"yyyy"}}</em> ο αριθμός των δημοτών ήταν <em>{{residents | number}}</em> παρουσιάζοντας <em>μεταβολή κατά {{increase | number}}</em> σε σχέση με το {{last_date | date: "yyyy"}}.',
                        'phrase:population-relocations': 'Κατά τη διάρκεια του ίδιου έτους ο η πόλη καλωσόρισε <em>{{inbound}} νέους δημότες</em>, όμως την ίδια περίοδο υπήρξαν <em>{{outbound}} μεταδημοτεύσεις</em> προς άλλους δήμους.',
                        'phrase:population-voters': 'Οι εγγεγραμμένοι στους <em>εκλογικούς κατάλογους</em> ήταν <em>{{voters | number}}</em>.',

                        'see more': 'περισσότερα'
                    },
                    'the-citizens': {
                        'The Citizens': 'Οι πολίτες',

                        'phrase:citizens-good-news': 'Το <em>πρώτο εξάμηνο του {{date | date:"yyyy"}}</em>, <em>{{weddings}}</em> ζευγάρια <em>παντρεύτηκαν</em> και ο δήμος μεγάλωσε κατά <em>{{births}} νεογέννητους πολίτες!</em>',
                        'phrase:citizens-bad-news': 'Από την άλλη πλευρά, <em>{{divorces}} ζευγάρια χώρισαν</em> και <em>{{deaths}} πολίτες έχασαν τη ζωή τους</em>.',

                        'see more': 'περισσότερα'
                    },
                    'budget': {
                        'Budget execution': 'Εκτέλεση προϋπολογισμού {{year}}',

                        'phrase:summary': '<em>Έσοδα {{revenue.collected | number}}&euro;</em> (εκ των οποίων {{remainder.collected | number}}&euro; αποτελεί χρηματικό υπόλοιπο)<br/><em>Έξοδα {{expenses.paid | number}}&euro;</em>',

                        'see more': 'περισσότερα'
                    }
                }

            },

            'civil-register': {

                'api-i18n:name': 'name_el',

                'The citizens': 'Οι πολίτες',
                'births': 'γεννήσεις',
                'deaths': 'θάνατοι',
                'divorces': 'διαζύγια',
                'weddings': 'γάμοι',

                'Date': 'Ημερομηνία',
                'Civil Register': 'Ληξιαρχείο',
                'Grouped': 'Ομαδοποιημένα',
                'Stacked': 'Σε στοίβα',
                'Category': 'Κατηγορία',
                'Start Year': 'Έναρξη',
                'End Year': 'Λήξη',
                'Male births': 'Γεννήσεις, αγόρια',
                'Female births': 'Γεννήσεις, κορίτσια',
                'Male deaths': 'Θάνατοι, άνδρες',
                'Female deaths': 'Θάνατοι, γυναίκες',
                'Religious weddings': 'Θρησκευτικοί γάμοι',
                'Civil weddings': 'Πολιτικοί γάμοι',
                'Civil unions': 'Σύμφωνα συμβίωσης',
                'Divorces': 'Διαζύγια',
                '1st Semester': '1ο Εξάμηνο',
                '2nd Semester': '2ο Εξάμηνο',

                'ui:filename': 'Ληξιαρχείο - {{category}} από {{fromYear}} έως {{toYear}}.{{extension}}'
            },

            'fiscal-data': {
                'Fiscal data': 'Οικονομικά στοιχεία',
                'Budget execution': 'Εκτέλεση προϋπολογισμού',

                'Revenue': 'Έσοδα',
                'Remainder': 'Χρηματικό Υπόλοιπο',
                'Expenses': 'Έξοδα',
                'Start Year': 'Έναρξη',
                'End Year': 'Λήξη',
                'Codes': 'Κωδικός',
                'Show analysis': 'Εμφάνιση ανάλυσης',
                'Hide analysis': 'Απόκρυψη ανάλυσης',

                'Stream': 'Ροή',
                'Stacked': 'Σε στοίβα',
                'Expanded': 'Σε επέκταση',
                'Total': 'Σύνολο'

            },

            'municipal-roll': {
                'Date': 'Ημερομηνία',
                'Municipal Roll': 'Δημοτολόγιο',
                'Start Year': 'Έναρξη',
                'End Year': 'Λήξη',
                'Residents': 'Δημότες',
                'Registered voters': 'Εγγεγραμμένοι εκλογικών καταλόγων',
                'Outbound residents': 'Μεταδημοτεύσεις από το Δήμο Ηρακλείου',
                'Inbound residents': 'Μεταδημοτεύσεις προς τον Δήμο Ηρακλείου',
                'Foreigner inbound residents': 'Αριθμός αλλοδαπών που έγιναν δημότες Ηρακλείου',

                'Grouped': 'Ομαδοποιημένα',
                'Stacked': 'Σε στοίβα',

                'ui:filename': 'Δημοτολόγιο από {{fromYear}} έως {{toYear}}.{{extension}}'
            },

            'library': {
                'Library': 'Βικελαία Βιβλιοθήκη',
                'Start Year': 'Έναρξη',
                'End Year': 'Λήξη',
                'Date': 'Ημερομηνία',

                'Members': 'Αριθμός μελών',
                'Total books': 'Συνολικός αριθμός βιβλίων',
                'Books for lending': 'Βιβλία προς δανεισμό',
                'Lended books': 'Δανεισμοί',
                'book titles': 'τίτλοι βιβλιων',
                'lendings': 'δανεισμοί',
                'members': 'μέλη',

                '1st Semester': '1ο εξάμηνο',
                '2nd Semester': '2ο εξάμηνο',

                'phrase:description': 'Η Βικελαία βιβλιοθήκη έχει <em>{{members | number}} εγγεγραμμένα μέλη</em>. Διαθέτει <em>{{total_books | number}} τίτλους βιβλίων</em> από τα οποία τα <em>{{books_for_lending | number}} είναι διαθέσιμα προς δανεισμό</em>.<br/>Το {{semester == 1 ? \'1ο\':\'2ο\'}} εξάμηνο του {{date | date:\'yyyy\'}} τα μέλη της <em>δανείστηκαν {{lended_books | number}} βιβλία</em>.',

                'ui:filename': 'Βικελαία Δημοτική Βιβλιοθήκη από {{fromYear}} έως {{toYear}}.{{extension}}'
            },

            'social-service': {
                'Social service': 'Κοινωνική υπηρεσία',
                'Start Year': 'Έναρξη',
                'End Year': 'Λήξη',
                'Date': 'Ημερομηνία',

                '1st Semester': '1ο εξάμηνο',
                '2nd Semester': '2ο εξάμηνο',

                'Number of funded social programs': 'Χρηματοδοτούμενα προγραμμάτα',
                'Social service benefiters': 'Ωφελούμενοι Κοινωνικής Υπηρεσίας',
                'Ergotherapy benefiters': 'Ωφελούμενοι Υπηρεσίας Εργοθεραπείας',
                'Medical service benefiters': 'Ωφελούμενοι Ιατρονοσηλευτικής Υπηρεσίας',
                'Physiotherapy benefiters': 'Ωφελούμενοι Υπηρεσίας Φυσιοθεραπείας',
                'Obstetrics benefiters': 'Ωφελούμενοι Μαιευτικής Υπηρεσίας',
                'Allowance policy benefiters': 'Ωφελούμενοι Επιδοματικής Πολιτικής',
                'Municipal clinics benefiters': 'Ωφελούμενοι Δημοτικού Ιατρείου',
                'Social grocery benefiters': 'Ωφελούμενοι κοινωνικού παντοπωλείου',
                'Homeless center benefiters': 'Ωφελούμενοι κέντρου αστέγων',
                'FEAD benefiters': 'Ωφελούμενοι ΤΕΒΑ',

                'ui:filename': 'Κοινωνική υπηρεσία από {{fromYear}} έως {{toYear}}.{{extension}}'
            }
        });
    }
})();